import { render, staticRenderFns } from "./newsletter-list-table.vue?vue&type=template&id=a4376502&"
import script from "./newsletter-list-table.vue?vue&type=script&lang=js&"
export * from "./newsletter-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports